import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1f249cc2&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "../style/activities.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f249cc2')) {
      api.createRecord('1f249cc2', component.options)
    } else {
      api.reload('1f249cc2', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=1f249cc2&", function () {
      api.rerender('1f249cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/activities/list.vue"
export default component.exports